import { deduplicateClassName } from "./deduplicateClassName.js";
import { flatClassNameList } from "./flatClassNameList.js";
function listClassName(list) {
  return deduplicateClassName(flatClassNameList(list)).join(" ");
}
export {
  listClassName
};
//# sourceMappingURL=listClassName.js.map
